<!-- @format -->

<template>
	<el-form
		v-if="forms"
		ref="form"
		:model="params"
		width="30%"
		:inline="inline"
		:label-position="'left'"
		:label-width="labelWidth ? labelWidth + 'px' : ''"
		:label-suffix="labelSuffix"
		class="ibps-crud__search-form platform-input-sty"
		@keyup.enter.stop="handleEnter"
		@submit.prevent
	>
		<el-row :gutter="20">
			<el-col
				v-for="(item, index) in forms"
				:key="index"
				:style="{
					display: isExpand ? (index > indexNum ? 'none' : 'inline') : 'inline',
					margin: '5px 0px',
					'text-align': 'left',
				}"
				:span="item.fieldType === 'daterange' ? 12 : 6"
			>
				<el-form-item
					:prop="item.modelValue"
					:rules="item.rules || []"
					:label-width="getLabelWidth(item.label) + 4 + 'px'"
				>
					<template #label>
						{{ item.label }}
					</template>
					<!-- 文本框-->
					<el-input
						v-if="item.fieldType === 'input' || item.fieldType === undefined"
						v-model="params[item.modelValue]"
						:size="item.size ? item.size : size"
						:readonly="item.readonly"
						:placeholder="'请输入'"
						:disabled="item.disabled"
						:style="itemStyle + (item.itemWidth ? `width: ${item.itemWidth}%;` : '')"
						:name="item.prop"
						clearable
						@keyup.enter.stop="handleEnter"
					/>
					<!-- 下拉框-->
					<el-select
						v-else-if="item.fieldType === 'select'"
						v-model="params[item.modelValue]"
						:size="item.size ? item.size : size"
						:disabled="item.disabled"
						:placeholder="item.placeholder ? item.placeholder : '请选择'"
						:style="itemStyle + (item.itemWidth ? `width: ${item.itemWidth}px;` : '')"
						clearable
						@keyup.enter.stop="handleEnter"
					>
						<el-option
							v-for="(option, optionIndex) in item.options"
							:key="optionIndex + '_local'"
							:label="typeof option === 'object' ? option[item.labelKey || 'label'] : option"
							:value="typeof option === 'object' ? option[item.valueKey || 'value'] : option"
						/>
						<el-option
							v-for="(op, opIndex) in selectOptions[selectOptionPrefix + index]"
							:key="opIndex + '_remote'"
							:value="typeof op === 'object' ? op[item.valueKey || 'value'] : op"
							:label="typeof op === 'object' ? op[item.labelKey || 'label'] || op[item.labelKey || 'label'] : op"
						/>
					</el-select>
					<!-- 日期范围-->
					<el-tooltip
						v-else-if="item.fieldType === 'daterange'"
						:disabled="params[item.modelValue] && params[item.modelValue][0] !== '' ? false : true"
						class="item"
						effect="dark"
						placement="top-start"
						:content="getDatatips(params[item.modelValue])"
					>
						<!-- 包裹 div 是为了解决控制台报错，报错信息为 Runtime directive used on component with non-element root node  -->
						<div style="width: 100%">
							<el-date-picker
								v-model="params[item.modelValue]"
								:size="item.size ? item.size : size"
								:disabled="item.disabled"
								:readonly="item.readonly"
								:editable="item.editable"
								:placeholder="item.placeholder ? item.placeholder : '请选择'"
								:start-placeholder="item.startPlaceholder ? item.startPlaceholder : '请选择'"
								:end-placeholder="item.endPlaceholder ? item.endPlaceholder : '请选择'"
								:style="itemStyle + (item.itemWidth ? `width: ${item.itemWidth}px;` : '')"
								:picker-options="item.pickerOptions || {}"
								type="daterange"
								@change="(date) => changeDate(date, item.prop[0], item.prop[1])"
								@keyup.enter.stop="handleEnter"
							/>
						</div>
					</el-tooltip>
					<!-- 自定义slot-->
					<template v-else-if="item.fieldType === 'slot'">
						<slot :name="item.slotName" :item="item" />
					</template>
				</el-form-item>
			</el-col>
			<el-col :span="searchBtnSpan" class="btn-mt-5">
				<div class="platform-fr">
					<el-button v-if="displayIcon" class="btn-ml-10" link @click="handleCollapseExpandToolbar()">
						展开
						<el-icon style="margin-left: 4px">
							<CaretTop v-if="!isExpand" />
							<CaretBottom v-else />
						</el-icon>
					</el-button>
					<slot name="searchToolbars" />
					<!-- <el-link
						v-show="displayIcon"
						type="primary"
						:underline="false"
						class="openPutSty"
						@click="handleCollapseExpandToolbar()"
					>
						<el-icon v-if="isExpand"><ArrowDown /></el-icon>
						<el-icon v-else><ArrowUp /></el-icon>
						{{ isExpand ? '展开' : '收起' }}
					</el-link> -->
				</div>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
	import { getTextFullLength } from '../../utils';
	import { formProps } from './props.js';
	import fecha from './fecha';
	import { $utils } from '@/utils/publicUtils';
	const formLabelFontSize = 14;

	export default {
		name: 'IbpsSearchForm',
		props: formProps,
		data() {
			const { forms, fuzzy } = this.$props;
			const datePrefix = 'daterange-prefix';
			const selectOptionPrefix = 'select-option-prefix';
			const dataObj = {
				selectOptions: {},
			};
			const params = {};
			const nameParams = {};
			const format = {};
			const fuzzyOps = {};
			const SEARCH_SPAN_MAP = {
				daterange: 12,
			};

			forms.forEach((v, i) => {
				const propType = typeof v.prop;
				if (propType === 'string') {
					v.modelValue = v.prop;
					params[v.prop] = v.value || '';
					if (v.name) {
						nameParams[v.prop] = v.name;
					}

					fuzzyOps[v.prop] = v.fuzzy ? v.fuzzy : fuzzy;
					if (v.format) {
						format[v.prop] = v.format;
					}
				} else if (propType === 'object' && Object.prototype.toString.call(v.prop) === '[object Array]') {
					v.prop.forEach((vv, j) => {
						params[vv] = vv.value || '';
						if (v.name) {
							nameParams[vv] = v.name[j];
						}
						if (v.format) {
							format[vv] = v.format;
						}
						fuzzyOps[vv] = v.fuzzy ? v.fuzzy : fuzzy;
					});
				}
				if (v.fieldType === 'daterange') {
					params[datePrefix + i] = '';
					v.modelValue = datePrefix + i;
				} else if (v.fieldType === 'select' && (v.selectFetch || v.selectUrl)) {
					const dataKey = selectOptionPrefix + i;
					dataObj.selectOptions[dataKey] = [];
					if (!v.selectMethod) {
						v.selectMethod = 'get';
					}
					this.getRemoteData({
						fetch: v.selectFetch
							? v.selectFetch
							: () => {
									const p = v.selectMethod.toLowerCase() === 'get' ? { params: v.selectParams } : v.selectParams;
									return request({
										url: v.selectUrl,
										method: v.selectMethod,
										p,
									});
							  },
						dataKey,
						resultField: v.resultField || 'data',
						resultHandler: v.resultHandler,
					});
				}
			});
			return {
				params,
				nameParams,
				datePrefix,
				selectOptionPrefix,
				...dataObj,
				format,
				fuzzyOps,
				buttonStatus: true,
				stopTime: null,
				isExpand: true,
				clientWidth: document.body.clientWidth,
				SEARCH_SPAN_MAP,
			};
		},
		computed: {
			itemStyle() {
				const { itemWidth } = this;
				if (itemWidth) {
					return `width: ${itemWidth}%;`;
				}
				return '';
			},
			indexNum() {
				if (this.clientWidth >= 1920) {
					return 2;
				} else if (this.clientWidth >= 1200 && this.clientWidth < 1920) {
					return this.selector ? 1 : 2;
				} else {
					return 0;
				}
			},
			offset() {
				let lableNum = 0;
				let offsetNum = 0;
				if (this.clientWidth >= 1920) {
					lableNum = 4;
					offsetNum = 6;
				} else if (this.clientWidth >= 1200 && this.clientWidth < 1920) {
					lableNum = this.selector ? 3 : 4;
					offsetNum = this.selector ? 8 : 6;
				} else {
					lableNum = 2;
					offsetNum = 12;
				}
				// 展开
				if (this.isExpand) {
					return this.forms.length < lableNum ? Math.abs(lableNum - 1 - this.forms.length) * offsetNum : 0;
				} else {
					// 收缩
					return Math.abs(lableNum - 1 - (this.forms.length % lableNum)) * offsetNum;
				}
			},
			displayIcon() {
				if (this.clientWidth >= 1920) {
					return !(this.forms.length < 4);
				} else if (this.clientWidth >= 1200 && this.clientWidth < 1920) {
					return !((this.selector && this.forms.length < 3) || (!this.selector && this.forms.length < 4));
				} else {
					return !(this.forms.length < 1);
				}
			},
			searchBtnSpan() {
				const count = (this.isExpand ? this.forms.slice(0, this.indexNum + 1) : this.forms).reduce((count, it) => {
					const itSpan = this.SEARCH_SPAN_MAP[it.fieldType] || 6;
					const spans = count + itSpan;
					if (spans === 24) {
						return 0;
					} else if (spans > 24) {
						return itSpan;
					}
					return spans;
				}, 0);
				console.log(this.forms, count);
				return 24 - count;
			},
		},
		beforeUnmount() {
			this.params = null;
			this.nameParams = null;
			this.format = null;
			this.fuzzyOps = null;
			this.stopTime = null;
		},
		methods: {
			handleResize() {
				this.clientWidth = document.body.clientWidth;
			},
			handleCollapseExpandToolbar() {
				this.isExpand = !this.isExpand;
				this.$emit('collapse-expand-toolbar', this.isExpand);
			},
			/**
			 * 处理回车
			 */
			handleEnter() {
				this.$emit('search');
			},
			isArray(value) {
				return typeof value === 'object' && Object.prototype.toString.call(value) === '[object Array]';
			},
			getParamFuzzy() {
				return this.fuzzyOps;
			},
			/**
			 * 获取参数
			 */
			getParams(callback) {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						const { params, nameParams, datePrefix, format } = this;
						const formattedForm = {};
						Object.keys(params).forEach((v) => {
							if (v.indexOf(datePrefix) === -1) {
								const val = format[v] ? format[v](params[v], v) : params[v];
								if ($utils.isNotEmpty(val)) {
									let key = v;
									if (nameParams[v]) {
										key = nameParams[v];
									}
									formattedForm[key] = val;
								}
							}
						});
						if (callback) callback(null, formattedForm);
					} else {
						if (callback) callback(new Error());
					}
				});
			},
			/**
			 *重置表单
			 */
			resetSearchForm() {
				try {
					this.$refs['form'].resetFields();
				} catch (error) {
					console.error(error);
				}
				const { params, datePrefix } = this;
				Object.keys(params).forEach((v) => {
					if (v && v.indexOf(datePrefix) === -1) {
						params[v] = '';
					}
				});
			},
			changeDate(date, startDate, endDate) {
				let dates;
				if (date === null) {
					this.params[startDate] = '';
					this.params[endDate] = '';
					return;
				}
				if (typeof date === 'string') {
					dates = date.split(' - ');
				} else if (date && Object.prototype.hasOwnProperty.call(date, 'length')) {
					const firstDate = date[0];
					const secondDate = date[1];
					dates = [
						`${firstDate.getFullYear()}-${`0${firstDate.getMonth() + 1}`.substr(-2)}-${`0${firstDate.getDate()}`.substr(
							-2,
						)}`,
						`${secondDate.getFullYear()}-${`0${secondDate.getMonth() + 1}`.substr(
							-2,
						)}-${`0${secondDate.getDate()}`.substr(-2)}`,
					];
				}
				this.params[startDate] = dates[0];
				this.params[endDate] = dates[1];
			},
			/**
			 * 获取的远程数据【下拉框】
			 */
			getRemoteData({ fetch, dataKey, resultField }) {
				fetch({}).then((response) => {
					let result = response;
					if (typeof response === 'object' && !this.isArray(response)) {
						if (resultField.indexOf('.') !== -1) {
							resultField.split('.').forEach((vv) => {
								result = result[vv];
							});
						} else {
							result = response;
						}
					}
					if (!result || !(result instanceof Array)) {
						throw new Error(`The result of key:${resultField} is not Array.`); // 接口返回的字段:${resultField} 不是一个数组
					}
					if (this.resultHandler) {
						this.selectOptions[dataKey] = result.map(this.resultHandler);
					} else {
						this.selectOptions[dataKey] = result;
					}
				});
			},
			getLabelWidth(label) {
				const labelLength = getTextFullLength(label);
				const labelSuffixLength = getTextFullLength(this.labelSuffix);
				return ((labelLength + labelSuffixLength) * formLabelFontSize) / 2;
			},
			getDatatips(date) {
				if ($utils.isNotEmpty(date) && date[0] !== '') {
					return `${fecha.format(date[0], 'yyyy-MM-dd')} ~ ${fecha.format(date[1], 'yyyy-MM-dd')}`;
				} else {
					return '';
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	// .openPutSty {
	// 	display: inline-block;
	// 	height: 32px !important;
	// 	text-align: center;
	// 	line-height: 32px;
	// 	background: #f7f8fa;
	// 	border-radius: 2px;
	// 	font-weight: 400;
	// 	padding: 1px 10px 1px 6px;
	// 	margin-left: 10px;
	// }

	.btn-mt-5 {
		margin-top: 5px;
		margin-bottom: 15px;
	}
	.btn-ml-10 {
		margin-right: 12px;
	}
</style>
